import { aboutContent, siteInfo, testimonials } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-sm font-label font-medium text-primary-700">
              <span className="w-6 h-[2px] bg-primary-500" aria-hidden="true"></span>
              关于我们
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              一间把娱乐影像资料整理清楚的档案室
            </h2>
            <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
              {aboutContent.story}
            </p>

            <div className="mt-6 flex items-start gap-3 p-5 rounded-lg bg-primary-50 border border-primary-200">
              <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-focus-3-line" aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                  我们的定位
                </p>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                  {aboutContent.positioning}
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-950 mb-5">
              内容原则
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {aboutContent.principles.map((item, index) => (
                <article
                  key={item.title}
                  className="bg-background-100 border border-background-200 rounded-lg p-5"
                >
                  <span className="font-heading font-bold text-sm text-accent-600">0{index + 1}</span>
                  <h4 className="mt-2 font-heading font-semibold text-base text-foreground-950">
                    {item.title}
                  </h4>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </article>
              ))}
            </div>

            <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-950 mt-10 mb-5">
              用户怎么说
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5"
                >
                  <i className="ri-double-quotes-l text-2xl text-secondary-400" aria-hidden="true"></i>
                  <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                    {t.text}
                  </blockquote>
                  <figcaption className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
                    <span className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                      <img
                        src={t.avatar}
                        alt={`${t.name} 的头像`}
                        className="w-full h-full object-cover object-top"
                      />
                    </span>
                    <span className="flex flex-col">
                      <span className="text-sm font-medium text-foreground-950">{t.name}</span>
                      <span className="text-xs text-foreground-500">{t.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="flex items-center gap-3 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
              <i className="ri-mail-line text-xl" aria-hidden="true"></i>
            </span>
            <div className="min-w-0">
              <p className="text-xs text-foreground-500">联系邮箱</p>
              <a
                href={`mailto:${siteInfo.email}`}
                className="text-sm font-medium text-foreground-900 hover:text-primary-700 transition-colors break-all cursor-pointer"
              >
                {siteInfo.email}
              </a>
            </div>
          </div>
          <div className="flex items-center gap-3 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
              <i className="ri-refresh-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-xs text-foreground-500">更新频率</p>
              <p className="text-sm font-medium text-foreground-900">专区每日更新，热点即时收录</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-5 rounded-lg bg-secondary-50 border border-secondary-200">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-500 text-background-50 shrink-0">
              <i className="ri-shield-check-line text-xl" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-xs text-foreground-500">内容异议</p>
              <p className="text-sm font-medium text-foreground-900">24 小时内响应处理</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}